<p class='dimensions-info__content' [innerHTML]='dimensionsInfo'></p>